import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_BULK_META, CREATE_BULK_META_SUCCESS, CREATE_BULK_META_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createBulkMeta({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/category-metadata/bulk`,
      method: 'POST',
      data: payload.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_BULK_META_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_BULK_META_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_BULK_META_ERROR, payload: error });
  }
}

export function* watchCreateBulkMeta() {
  yield takeEvery(CREATE_BULK_META, createBulkMeta);
}

function* createBulkMetaSaga() {
  yield all([fork(watchCreateBulkMeta)]);
}

export default createBulkMetaSaga;
